import Hero from "../components/Hero";
import Navbar from "../components/Navbar";
import Team from "../components/Team";
import { TeamList, AdvisorList, PIList, InstructorList } from "../components/Teamlist";
import Footer from "../components/Footer";


function Members(){
    return(
        <>
            <Navbar/>
            <Hero
                cName="hero-content" 
                heroImg="https://static.igem.wiki/teams/4696/wiki/hhhero-fig4.jpg"
                title="Members"
            />
            <div className="row">
                <h1>Our Team</h1>
            </div>
            <section >
                <div className="row">
            {TeamList.map((item)=>{
                return(
                    <Team photo={item.photo} Name={item.Name} Role={item.Role} Major={item.Major} Department={item.Department} />
                )
            })}</div></section>

            <div className="row">
                <h1>Our Instructors</h1>
            </div>
            <section >
                <div className="row">
            {InstructorList.map((item)=>{
                return(
                    <Team photo={item.photo} Name={item.Name} Role={item.Role} Major={item.Major} Department={item.Department} />
                )
            })}</div></section>           

            <div className="row">
                <h1>Our Advisors</h1>
            </div>
            <section >
                <div className="row">
            {AdvisorList.map((item)=>{
                return(
                    <Team photo={item.photo} Name={item.Name} Role={item.Role} Major={item.Major} Department={item.Department} />
                )
            })}</div></section>


            <div className="row">
                <h1>Our Principal Investigators</h1>
            </div>
            <section >
                <div className="row">
            {PIList.map((item)=>{
                return(
                    <Team photo={item.photo} Name={item.Name} Role={item.Role} Major={item.Major} Department={item.Department} />
                )
            })}</div></section>


            <Footer/>
        </>
    )
}

export default Members;


